import { Component, OnInit } from '@angular/core';
import * as $AB from 'jquery';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-sellheader',
  templateUrl: './sellheader.component.html',
  styleUrls: ['./sellheader.component.css']
})
export class SellheaderComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
      var Router=this.router;
      $(".walletlink").click(function(){
      Router.navigate(['/wallet']);
      })
       $(".notification_show").click(function(){
         $(".dropdown-menu-anim").removeClass("d-none").addClass("d-block");
        });
         $(document).mouseup(function(){
             $(".dropdown-menu-anim").removeClass("d-block").addClass("d-none");
         });

         $(".quick_action").click(function(){
            $(".quick_action_show").removeClass("d-none").addClass("d-block");
          });
        $(document).mouseup(function(){
             $(".quick_action_show").removeClass("d-block").addClass("d-none");
        });

         $(".coupon_action").click(function(){
            $(".coupon_action_show").removeClass("d-none").addClass("d-block");
          });
        $(document).mouseup(function(){
             $(".coupon_action_show").removeClass("d-block").addClass("d-none");
        });

         $(".profile-pic").click(function(){
	         $(".dropdown-menu-anim-profile").removeClass("d-none").addClass("d-block");
	        });
           $(document).mouseup(function(){
             $(".dropdown-menu-anim-profile").removeClass("d-block").addClass("d-none");
           });
            $(document).on('click', '.dropdown-menu-anim ul li a', function (e) {
          e.stopPropagation();
        });
  }


}
